import { render, staticRenderFns } from "./phb.vue?vue&type=template&id=05b28840"
import script from "./phb.vue?vue&type=script&lang=js"
export * from "./phb.vue?vue&type=script&lang=js"
import style0 from "./phb.vue?vue&type=style&index=0&id=05b28840&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports